import { Wrench, Users, DollarSign } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

interface WelcomeStepProps {
  onNext: () => void;
}

export function WelcomeStep({ onNext }: WelcomeStepProps) {
  const { user } = useAuth();
  const firstName = user?.name?.split(' ')[0] ?? 'Gestor';

  return (
    <div className="flex flex-1 flex-col items-center justify-center px-6 text-center">
      <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-muted">
        <Wrench size={32} className="text-muted-foreground" />
      </div>

      <h1 className="text-2xl font-bold text-foreground">
        Bem-vindo, {firstName}! Vamos configurar sua oficina.
      </h1>
      <p className="mt-2 text-muted-foreground">Leva menos de 5 minutos.</p>

      <div className="mt-8 space-y-4 text-left">
        <div className="flex items-start gap-3">
          <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-emerald-100 dark:bg-emerald-950/40">
            <Wrench size={16} className="text-emerald-700 dark:text-emerald-300" />
          </div>
          <div>
            <p className="text-sm font-medium">Dados da oficina</p>
            <p className="text-xs text-muted-foreground">
              Nome, endereço, especialidades e horários
            </p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blue-100 dark:bg-blue-950/40">
            <Users size={16} className="text-blue-700 dark:text-blue-300" />
          </div>
          <div>
            <p className="text-sm font-medium">Convide sua equipe</p>
            <p className="text-xs text-muted-foreground">
              Gere um link para seus mecânicos entrarem
            </p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-950/40">
            <DollarSign size={16} className="text-amber-700 dark:text-amber-300" />
          </div>
          <div>
            <p className="text-sm font-medium">Tabela de preços</p>
            <p className="text-xs text-muted-foreground">
              Configure os valores da mão de obra
            </p>
          </div>
        </div>
      </div>

      <button
        onClick={onNext}
        className="mt-10 rounded-lg bg-primary px-8 py-3 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
      >
        Vamos começar
      </button>
    </div>
  );
}
